 <!-- Hide the PO panel while the implementation charge dialog is open, so only the dialog shows.
      Transient only: refreshing before accepting the implementation charge shows the panel again. -->
 @if (!implementationModalConfig.visible) {
 <panel [panelInput]="panelConfig" (close)="fnClosePanel()">
    <ng-container panel-body>

      <!-- Start Purchase Order -->
      <div class="border-content__area" #poCaptureArea>
        <div class="border-content__area input-no-margin">
          <div class="three-col-grid">
            <ds-textbox [textboxInput]="preparedByConfig"></ds-textbox>
            <ds-textbox [textboxInput]="emailConfig"></ds-textbox>
            <ds-textbox [textboxInput]="dateConfig"></ds-textbox>
          </div>
        </div>
        <div class="d-flex gap-16">
          <div class="flex-2 d-flex flex-column">
            <div class="border-content__area__white flex-grow-1">
              <div class="d-flex align-items-center justify-content-between gap-8">
                <h6 class="title-12">{{ 'new_onb_po_agreed_terms' | translate }}</h6>
                <div class="grid-status --pending no-bullet">
                  <span class="tag-text">{{ 'new_onb_valid_for_7_days' | translate }}</span>
                </div>
              </div>
              <hr class="hr-border-muted">
              <div class="three-col-grid input-no-margin">
                <ds-textbox [textboxInput]="planTypeConfig"></ds-textbox>
                <ds-textbox [textboxInput]="numberOfUsersConfig"></ds-textbox>
                <ds-textbox [textboxInput]="implementationCostConfig"></ds-textbox>
              </div>

              <!-- Per user-type breakdown of the agreed terms. Read-only: these are the figures
                   sales agreed, and the two counts always add up to the total users above.
                   `rounded-corners` supplies the bordered look with a rule between every column. -->
              <table class="table rounded-corners --header-divided w-100pc mb-0">
                <thead>
                  <tr>
                    <th>{{ 'new_onb_po_user_type' | translate }}</th>
                    <th class="table-col--narrow">{{ 'label_count' | translate }}</th>
                    <th class="text-end">{{ 'new_onb_plan_price' | translate }}</th>
                    <th class="text-end">{{ 'new_onb_po_access_charge' | translate }}</th>
                    <th class="text-end">{{ 'new_onb_po_total_per_user' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ 'new_onb_power_users' | translate }}</td>
                    <td class="input-no-margin">
                      <div class="eod-input input--sm">
                        <input class="form-control" id="num-power-users" type="text" readonly
                          [value]="numberOfPowerUsers">
                      </div>
                    </td>
                    <td class="text-end">{{ planPrice | number: '1.2-2' }} {{ paymentCurrencyCode }}</td>
                    <td class="text-end">{{ powerUserBasicPrice | number: '1.2-2' }} {{ paymentCurrencyCode }}</td>
                    <td class="text-end">{{ powerUserTotalPerUser | number: '1.2-2' }} {{ paymentCurrencyCode }}</td>
                  </tr>
                  <tr>
                    <td>{{ 'new_onb_po_casual_users' | translate }}</td>
                    <td class="input-no-margin">
                      <div class="eod-input input--sm">
                        <input class="form-control" id="num-casual-users" type="text" readonly
                          [value]="casualUserCount">
                      </div>
                    </td>
                    <td class="text-end">&ndash;</td>
                    <td class="text-end">{{ casualUserBasicPrice | number: '1.2-2' }} {{ paymentCurrencyCode }}</td>
                    <td class="text-end">{{ casualUserTotalPerUser | number: '1.2-2' }} {{ paymentCurrencyCode }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="flex-1 d-flex flex-column">
            <div class="quote-Summary flex-grow-1">
              <h6 class="title-12">{{ 'new_onb_po_quote_summary' | translate }}</h6>
              <div class="montly-billing-section">
                <p class="paragraph-12">{{ 'new_onb_po_min_monthly_billing' | translate }}</p>
                <h2><span class="amount">{{ minimumBilling | number: '1.2-2' }}</span><span> {{ paymentCurrencyCode }}</span></h2>
                <p>{{ 'new_onb_billing_formula' | translate:{ powerUsers: numberOfPowerUsers, powerTotal: (powerUserTotalPerUser | number: '1.2-2') + ' ' + paymentCurrencyCode, casualUsers: casualUserCount, casualTotal: (casualUserTotalPerUser | number: '1.2-2') + ' ' + paymentCurrencyCode } }}</p>
              </div>
              <hr class="hr-border-focus">
              <div class="d-flex flex-column gap-6">
                <div class="d-flex justify-content-between">
                  <p class="paragraph-12">{{ 'new_onb_total_users' | translate }}</p>
                  <p class="text-end title-12">{{ noOfUsers }}</p>
                </div>
                <div class="d-flex justify-content-between">
                  <p class="paragraph-12">{{ 'new_onb_power_users' | translate }}</p>
                  <p class="text-end title-12">{{ numberOfPowerUsers }}</p>
                </div>
                <div class="d-flex justify-content-between">
                  <p class="paragraph-12">{{ 'new_onb_po_impl_cost' | translate }}</p>
                  <p class="text-end title-12">{{ implementationCharge | number: '1.2-2' }} {{ paymentCurrencyCode }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="warning-info-section surface-secondary-subtle">
          <h6 class="title-12">{{ 'new_onb_agreed_pricing_plan' | translate }}</h6>
          <div class="three-col-grid">
            <div class="plan-selection__container border-active">
              <div class="plan-selection__content w-100pc">
                <div class="d-flex align-items-center justify-content-between gap-8 mb-1">
                  <h6>{{ bandPlanDetails?.planName }}</h6>
                  <div class="grid-status --success no-bullet">
                    <span class="tag-text">{{ 'new_onb_agreed_plan' | translate }}</span>
                  </div>
                </div>
                <p><span class="amount">{{ planPrice | number: '1.2-2' }} {{ paymentCurrencyCode }}</span> <span class="plan ms-1">({{ isYearlyPlan ? bandPlanDetails?.yearlyText : bandPlanDetails?.monthlyText }})</span></p>
                <div class="grid-status --primary no-bullet mt-2">
                  {{ bandPlanDetails?.infoText1 }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Acceptance checkboxes live inside the capture area so the agreed boxes appear on the receipt. -->
        @if (hasNotes) {
          <div class="secondary-info-container --borderless">
            <ds-checkbox [checkboxInput]="activationAckCheckboxConfig" (checkedChange)="onActivationAckChange($event)"></ds-checkbox>
          </div>
        }
        <div class="secondary-info-container --borderless">
          <ds-checkbox [checkboxInput]="acceptQuoteCheckboxConfig" (checkedChange)="onAcceptQuoteChange($event)"></ds-checkbox>
        </div>
        <div class="secondary-info-container --borderless flex-row justify-content-between align-items-center">
          <ds-checkbox [checkboxInput]="termsCheckboxConfig" (checkedChange)="onTermsChange($event)"></ds-checkbox>
          <ds-button [buttonInput]="termsOfServiceButtonConfig" (btnClick)="fnOpenTermsOfService()"></ds-button>
        </div>
      </div>
      <!-- End Purchase Order -->

    </ng-container>

    <ng-container panel-footer>
      <ds-button [buttonInput]="submitButtonConfig" (btnClick)="fnAcceptAndProceed()"></ds-button>
    </ng-container>
</panel>
}

<!-- One-time implementation charge -->
<ds-modal [modalInput]="implementationModalConfig" (visibleChange)="onImplementationModalVisibleChange($event)">
  <ng-container modal-body>
    <div class="d-flex flex-column gap-12">
      <div class="primary-info-container --borderless flex-row justify-content-between align-items-center">
        <div class="d-flex flex-column gap-12">
          <div class="icon-box-rounded surface-primary-emphasis --large-img"><img [src]="ICONS.API" alt="One-time implementation" /></div>
          <div>
            <h6 class="title-16 text-link-hover">{{ 'new_onb_one_time_implementation' | translate }}</h6>
            <p class="paragraph-12 text-placeholder">{{ 'new_onb_setup_migration_training' | translate }}</p>
          </div>
        </div>
        <h5 class="title-24 fw-700 text-primary">{{ implementationCharge | number: '1.2-2' }} {{ paymentCurrencyCode }}</h5>
      </div>
      <hr class="hr-border-muted">
      <div class="secondary-info-container --borderless gap-6">
        <h6 class="title-14">{{ 'new_onb_whats_included' | translate }}</h6>
        <ul class="ds-info-text --icon-check --success">
          <li>{{ 'new_onb_incl_account_config' | translate }}</li>
          <li>{{ 'new_onb_incl_historical_migration' | translate }}</li>
          <li>{{ 'new_onb_incl_category_tax' | translate }}</li>
          <li>{{ 'new_onb_incl_approval_workflow' | translate }}</li>
          <li>{{ 'new_onb_incl_training_session' | translate }}</li>
          <li>{{ 'new_onb_incl_golive_support' | translate }}</li>
        </ul>
      </div>
    </div>
      <ds-checkbox [checkboxInput]="implementationTermsCheckboxConfig" (checkedChange)="onImplementationTermsChange($event)"></ds-checkbox>
  </ng-container>
  <ng-container modal-footer>
    <ds-button [buttonInput]="proceedPaymentButtonConfig" (btnClick)="fnProceedToPayment()"></ds-button>
  </ng-container>
</ds-modal>

<!-- Off-screen copy of the Implementation Agreement, always rendered so it can be captured
     to PDF silently on load (the modal above is only in the DOM while it is open). -->
<div aria-hidden="true" style="position: absolute; left: -9999px; top: 0; width: 520px;">
  <div class="d-flex flex-column gap-12" #implementationCaptureArea>
    <div class="primary-info-container --borderless flex-row justify-content-between align-items-center">
      <div class="d-flex flex-column gap-12">
        <div class="icon-box-rounded surface-primary-emphasis --large-img"><img [src]="ICONS.API" alt="One-time implementation" /></div>
        <div>
          <h6 class="title-16 text-link-hover">{{ 'new_onb_one_time_implementation' | translate }}</h6>
          <p class="paragraph-12 text-placeholder">{{ 'new_onb_setup_migration_training' | translate }}</p>
        </div>
      </div>
      <h5 class="title-24 fw-700 text-primary">{{ implementationCharge | number: '1.2-2' }} {{ paymentCurrencyCode }}</h5>
    </div>
    <hr class="hr-border-muted">
    <div class="secondary-info-container --borderless gap-6">
      <h6 class="title-14">{{ 'new_onb_whats_included' | translate }}</h6>
      <!-- Same design-system list as the visible modal; the extra 'pdf-capture-check' class swaps the
           CSS mask() check (which html2canvas renders as a solid box) for a real check-mark character. -->
      <ul class="ds-info-text --icon-check --success pdf-capture-check">
        <li>{{ 'new_onb_incl_account_config' | translate }}</li>
        <li>{{ 'new_onb_incl_historical_migration' | translate }}</li>
        <li>{{ 'new_onb_incl_category_tax' | translate }}</li>
        <li>{{ 'new_onb_incl_approval_workflow' | translate }}</li>
        <li>{{ 'new_onb_incl_training_session' | translate }}</li>
        <li>{{ 'new_onb_incl_golive_support' | translate }}</li>
      </ul>
    </div>
    <!-- Agreed implementation-terms checkbox on the receipt (shares the config, so it reflects the ticked state). -->
    <div class="secondary-info-container --borderless">
      <ds-checkbox [checkboxInput]="implementationTermsCheckboxConfig"></ds-checkbox>
    </div>
  </div>
</div>


<!-- Real-time "PO withdrawn" overlay: blurs the whole screen and shows the message. -->
@if (isWithdrawn) {
  <div class="po-withdrawn-overlay" >
    <div class="po-withdrawn__content">
      <p>{{ 'new_onb_po_withdrawn_line1' | translate }}<br>{{ 'new_onb_po_withdrawn_line2' | translate }}</p>
    </div>
  </div>
}
